(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditLogController', AuditLogController);

    AuditLogController.$inject = ['$filter', 'AuditLogService', 'ParseLinks', '$state', 'pagingParams'];

    function AuditLogController($filter, AuditLogService, ParseLinks, $state, pagingParams) {
        var vm = this;

        vm.auditLog = null;
        vm.fromDate = pagingParams.fromDate;
        vm.toDate = pagingParams.toDate;
        vm.links = null;
        vm.filter = pagingParams.filter;
        vm.onChangeDate = onChangeDate;
        vm.predicates = pagingParams.predicates;
        vm.totalItems = null;
        vm.size = 20;
        vm.transition = transition;
        vm.applyFilter = applyFilter;
        vm.currentState = "audit-log";
        vm.searchText = pagingParams.search;
        vm.onChangeDate();

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        function onChangeDate() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditLogService.query({
                page: pagingParams.page - 1,
                sort: sort(),
                size: vm.size,
                fromDate: fromDate,
                toDate: toDate,
                action: vm.filter.activity,
                query: vm.searchText
            }, function (result, headers) {
                vm.auditLog = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.page = pagingParams.page;
            });
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }


        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                search: vm.searchText,
                predicates: vm.predicates,
                toDate: vm.toDate,
                fromDate: vm.fromDate,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.onChangeDate();
            vm.transition(false);
        };

        function applyFilter() {
            vm.onChangeDate();
        }
    }
})();
